module.exports = __webpack_public_path__ + "img/book_05.477e80c8.jpg";